import { customApiPrefix } from "./../../templates/apis/custom";
import { isJSStateModel } from "../../common/getStateModels";
// @ts-ignore
import { formatCodeWithMonaco } from '@tencent/ui-core/lib/utils/monaco';
import { MethodGenerateContext } from "../MethodGenerateContext";
import { FORM_METHOD_TYPES, METHOD_TYPES } from "../../stateCommon/consts";
import { getCustomMethodGenerator, getMethodGenerator } from "./generators";
import { getFormTypes, getListTypes, getRvFormTypes, getRvListTypes, METHOD_TEMPLATES } from "../utils/consts";
export async function generateMethod(generateOptions, format = true) {
  const ctx = new MethodGenerateContext({
    ...generateOptions
  });
  const {
    stateModel,
    cgi,
    tpl
  } = ctx;
  if (!isJSStateModel(stateModel)) {
    throw new Error(`generateMethod：不合法的模型类型 - ${stateModel}`);
  }
  const getMethod = tpl === METHOD_TEMPLATES.custom ? getCustomMethodGenerator(cgi) : getMethodGenerator(tpl);
  if (getMethod) {
    var _method$formInfo, _method$meta;
    const method = getMethod.generate(ctx);
    if (!format) {
      return method;
    }
    if (typeof method.code === 'string' && method.code.length >= 20) {
      method.code = await formatCodeWithMonaco(method.code.trim());
    }
    if (method.type === METHOD_TYPES.form && ((_method$formInfo = method.formInfo) === null || _method$formInfo === void 0 ? void 0 : _method$formInfo.type) === FORM_METHOD_TYPES.request) {
      const params = method.formInfo.params;
      params.request = await formatCodeWithMonaco(params.request);
    }
    method.unchanged = true;
    if (!((_method$meta = method.meta) !== null && _method$meta !== void 0 && _method$meta.tpl)) {
      // 一些纯代码的生成逻辑，这边需要把tpl补充下，不然无法重置方法
      method.meta = {
        ...method.meta,
        ...{
          tpl
        }
      };
    }
    return method;
  }
  throw new Error(`generateMethod: 找不到${cgi}对应的代码生成逻辑`);
}
export async function generateMethods(collection, stateModel, usage = undefined, extraConfig = {}) {
  const options = {
    collection,
    stateModel,
    init: true,
    extraConfig
  };
  // 根据用户已经配好的接口进行生成，还是直接生成常用的方法
  // const methodNames = getMethodNamesByModel(collection, stateModel, false, true);
  const generators = getMethodGeneratorByModel({
    collection,
    stateModel,
    usage,
    needEmpty: false,
    init: true
  });
  const generateOptions = generators.map(item => ({
    cgi: item.cgi,
    tpl: item.tpl,
    ...options
  }));
  const res = await Promise.all(generateOptions.map(item => generateMethod(item)));
  // formatCode是共用一个monaco的需要串行
  // for (const item of generateOptions) {
  //   try {
  //     const method = await generateMethod(item);
  //     res.push(method);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }
  return res;
}
// eslint-disable-next-line complexity
export function getMethodGeneratorByModel(options) {
  const {
    collection,
    stateModel,
    usage,
    needEmpty = false,
    init = false
  } = options;
  const mt = METHOD_TEMPLATES;
  const customCgis = Object.keys(collection.cgiInfo || {}).filter(name => name.startsWith(customApiPrefix));
  const customs = customCgis.map(item => getCustomMethodGenerator(item));
  let methods = [];
  if (stateModel === 'any_JS') {
    methods = [...Object.values(mt.any).map(getMethodGenerator)];
  }
  if (stateModel === 'form_JS') {
    const formMethods = getFormTypes().map(getMethodGenerator);
    methods = [...formMethods];
  }
  if (stateModel === 'rv_form_JS') {
    methods = getRvFormTypes().map(getMethodGenerator);
  }
  // if (stateModel === 'list_JS' && usage === 'local') {
  //   methods = getListTypes(usage).map(getMethodGenerator);
  // }
  if (stateModel === 'rv_list_JS') {
    methods = getRvListTypes(usage).map(getMethodGenerator);
    if (init) {
      methods = excludeListAndCountWithInit(methods);
    }
  }
  if (stateModel === 'list_JS') {
    let commonMethods = getListTypes(usage).map(getMethodGenerator);
    if (collection.type === 'http' || collection.type === 'sql') {
      const hasCount = !!collection.cgiInfo.count;
      commonMethods = commonMethods.filter(item => item.tpl !== mt.list.listCount && (hasCount ? true : item.tpl !== mt.list.count));
    } else {
      if (init) {
        commonMethods = excludeListAndCountWithInit(commonMethods);
      }
    }
    methods = [...commonMethods];
  }
  methods = [...methods, ...customs];
  if (needEmpty) {
    methods.push(getMethodGenerator(mt.empty));
  }
  methods = methods.filter(Boolean);
  if (!init) {
    methods = methods.filter(item => !item.tpl.endsWith('init'));
  }
  return methods;
}
/**
 * 初始化生成方法时 只需要 listCount一起请求的方法
 */
function excludeListAndCountWithInit(list) {
  const mt = METHOD_TEMPLATES;
  return list.filter(item => ![mt.list.list, mt.list.count].includes(item.tpl));
}
//# sourceMappingURL=index.js.map
